import { type InputHTMLAttributes, useId } from "react";

export interface TextFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  help?: string;
  error?: string | null;
}

/** Champ de saisie : libellé toujours visible, aide et erreur reliées au champ pour les lecteurs d'écran. */
export function TextField({ label, help, error, style, ...rest }: TextFieldProps) {
  const id = useId();
  const helpId = help ? `${id}-help` : undefined;
  const errorId = error ? `${id}-error` : undefined;
  return (
    <div style={{ display: "grid", gap: 4 }}>
      <label htmlFor={id} style={{ fontSize: 14, fontWeight: 500, color: "var(--sk-title)" }}>
        {label}
      </label>
      <input
        id={id}
        {...rest}
        aria-invalid={error ? true : undefined}
        aria-describedby={[helpId, errorId].filter(Boolean).join(" ") || undefined}
        style={{
          minHeight: 44,
          width: "100%",
          minWidth: 0,
          boxSizing: "border-box",
          padding: "10px 12px",
          borderRadius: "var(--sk-radius-sm)",
          border: `1.5px solid ${error ? "var(--color-corail)" : "var(--sk-border)"}`,
          background: "var(--sk-surface)",
          color: "var(--sk-text)",
          fontSize: 16, // 16 px : évite le zoom automatique sur mobile
          ...style,
        }}
      />
      {help && (
        <small id={helpId} style={{ fontSize: 12, color: "var(--sk-text-muted)" }}>
          {help}
        </small>
      )}
      {error && (
        <small
          id={errorId}
          role="alert"
          style={{
            fontSize: 14,
            color: "var(--sk-warn-text)",
            background: "var(--sk-warn-bg)",
            borderRadius: 8,
            padding: "6px 8px",
          }}
        >
          {error}
        </small>
      )}
    </div>
  );
}
